import { useEffect } from 'react';
export var useClassOnScroll = function useClassOnScroll(elementRef, className) {
  useEffect(function () {
    // 1. Проверка на пустой класс
    if (!className.trim()) {
      return undefined;
    }
    var handleScroll = function handleScroll() {
      var element = elementRef.current;
      // 2. Проверка существования элемента
      if (!element) return undefined;

      // 3. Безопасное добавление/удаление класса
      if (window.scrollY > 1) {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
      return true;
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, [className]);
};